<template>
  <div class="personalBox">
    <div class="perTopBox clearfix">
      <img src="@/assets/images/logo02.png" alt="" class="smlogo">
      <div class="navBox clearfix">
        <ul>
          <li v-for="(item,index) in navList" :key="item.valeu" @click="changeNav(index)" :class="{'isActive':item.isActive}">
            <img :src="item.isActive?item.url2:item.url1" alt="">
            <p>{{item.name}}</p>
          </li>
        </ul>
      </div>
      <div class="logOut">
        <img src="@/assets/images/icon12.png" alt="" class="photo">
        <span class="userName">{{userName}}</span>
        <!-- <img src="@/assets/images/icon16.png" alt=""> -->
        <img src="@/assets/images/icon13.png" alt="" class="signOut" @click="signOut">
      </div>
    </div>

    <div class="centerBox clearfix">

      <!-- 地图列表标签 -->
      <map-lists v-if="showTermThree"></map-lists>
      <!-- 创建索引标签 -->
      <create-index v-if="showTermTwo" v-on:backPersonal="backPersonal" :clickBtnObj="clickBtnObj"></create-index>
      <!-- 导入空间数据标签 -->
      <!-- <import-space-data v-if="showTermFour" v-on:backPersonal="backPersonal"></import-space-data> -->
      <!-- 空间数据详情标签 -->
      <sapce-data-detail :tblinfo="sptlTblInfo" v-if="showTermFive" v-on:backPersonal="backPersonal"></sapce-data-detail>
      <div class="leftBox clearfix" v-if="showTermOne">
        <!-- <div class="firstBox">
          <img src="@/assets/images/icon12.png" alt="" class="photo">
          <h4>{{userName}}</h4>
          <span class="jobName">GIS开发</span>
          <span class="departName">英泽科技有限公司——新业务交付部</span>
          <span class="addressName">花山软件新城</span>
        </div> -->
        <div class="chartBox">
            <div class="title">我的数据统计</div>
            <div id="myChart" :style="{width: '80%', height: '180px'}"></div>
            <div class="dataBox">
              <span class="bluePoint"></span>
              <span>数据资源占用(G)</span>
              <span class="bigTxt">{{dataSum}}</span>
              <br>
              <br>
              <span class="grayPoint"></span>
              <span>数据总容量(G)</span>
              <span class="bigTxt">{{dataSize}}</span>
            </div>
        </div>
        <div class="chartBox">
            <div class="title">我的地图统计</div>
            <div id="myChart1" :style="{width: '60%', height: '165px'}"></div>
            <div class="dataBox">
              <span class="bluePoint"></span>
              <span>已发布地图个数</span>
              <span class="bigTxt">{{mapCount}}</span>
              <br>
              <br>
              <span class="grayPoint"></span>
              <span>允许发布地图总数</span>
              <span class="bigTxt">{{mapSize}}</span>
            </div>
        </div>
        <div class="chartBox">
            <div class="title">我的索引统计</div>
            <div id="myChart2" :style="{width: '100%', height: '130px'}"></div>
            <div class="dataBox" style="right:120px;top:150px;">
              <span class="bluePoint"></span>
              <span>已发布个数</span>
              <span class="bigTxt">{{indCount}}</span>
              <span class="grayPoint"></span>
              <span>允许发布总数</span>
              <span class="bigTxt">{{indSize}}</span>
            </div>
        </div>
      </div>
      <div class="rightBox" v-if="showTermOne">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="'我的地图(' + mapCount + ')'" name="first">
            <div class="btnBox">
              <span class="mapPublish" @click="mapPublish">地图发布</span>
            </div>
            <ul class="mapList">
              <li v-for="item in mapListArrs" :key="item.value" class="mapLi clearfix">
                <img src="@/assets/images/icon47.png" alt=""  v-if="item.clicks == 0" id="newImgShow">
                <img :src="item.thumbnail" alt="" class="mapImg" @click="goMap(item)">
                <div class="mapInfo msgInfo">
                  <h4>{{item.serviceCname}}</h4>
                  <p>
                    <span class="grayTxt">地图说明：</span>{{item.remarks}}
                  </p>
                  <p>
                    <span class="grayTxt">空间坐标参考系：</span>{{item.wktShortName}}
                  </p>

                  <p >
                    <span class="grayTxt">地图标签：</span>
                    <ul class="labelList clearfix" style="vertical-align: middle; display: inline-block">
                      <li v-for="item1 in item.serviceflagArr" :key="item1.value" class="mapLabel">
                        {{item1.value}}
                      </li>
                    </ul>
                  </p>

                  <p >
                    <span class="grayTxt">地图类别：</span>{{item.mapTypeText}}
                  </p>
                  <div class="mapState">
                    <ul class="clearfix">
                      <li v-for="(item1,index1) in item.mapStates" :key="item1.value" @click="showDialog(item1.value,item,index1)">
                        <span :class="item1.sty"></span>{{item1.value}}
                      </li>
                    </ul>
                    <span class="stateTime">2019-11-24 13:34</span>
                  </div>
                </div>
                <div class="mapOperation">
                  <span class="deleteBtn" @click="deleteRowMap(item.id,1)">删除</span>
                  <span>|</span>
                  <span class="mapEdit" @click="editRowMap(item.id)">地图编辑</span>
                  <span class="mapEdit" @click="seeRowMap(item.id)">查看详情</span>
                </div>
              </li>
            </ul>
            <el-pagination
              @size-change="myMaphandleSizeChange"
              @current-change="myMaphandleCurrentChange"
              :current-page="myMapCrtPage"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="myMapSize"
              layout="sizes, prev, pager, next, jumper"
              :total="myMapTotal">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane :label="'我的数据(' + dataCount + ')'" name="second" id='mySptlData'>
            <div class="btnBox">
                <span class="dataIn" @click="importSpaceData">空间数据入库</span>
            </div>
            <ul class="dataList">
              <li v-for="item in dataLists" :key="item.value" class="mapLi clearfix">
                <img :src="item.thumUrl" alt="" class="mapImg" @click="showSptlDetail(item)">
                <!-- <div style="width:170px;height:120px;float:left;" :id="'map-main' + item.value" @click="showSptlDetail(item)"/> -->
                <div class="dataInfo msgInfo">
                  <h4>{{item.showTableName}}</h4>
                  <p :title="item.wktShortName">
                    <span class="grayTxt">空间坐标参考系：</span>{{item.wktShortName}}
                  </p>
                  <p :title="item.extent">
                    <span class="grayTxt">边界范围：</span>{{item.extent}}
                  </p>
                  <p>
                    <span class="grayTxt">空间数据类型：</span>{{item.sptlDataType}}
                  </p>
                  <p :title="item.instruction">
                    <span class="grayTxt">空间数据说明：</span>{{item.instruction}}
                  </p>
                  <p :title="item.usageScope">
                    <span class="grayTxt">空间数据使用范围：</span>{{item.usageScope}}
                  </p>
                </div>
                <div class="mapOperation">
                  <span class="deleteBtn" @click="deleteRowMap(item, 2)">删除</span>
                  <span>|</span>
                  <span class="dataEdit" @click="spaceDataEdit(item)">空间数据编辑</span>
                </div>
              </li>
            </ul>
            <el-pagination
              @size-change="mydataHandleSizeChange"
              @current-change="mydataHandleCurrentChange"
              :current-page="mydataCrtPage"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="mydataSize"
              layout="sizes, prev, pager, next, jumper"
              :total="mydataTotal">
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane :label="'我的索引(' + myIndexTotal + ')'" name="third" id='mySptlIndex'>
            <div class="btnBox">
                <span class="createInd" @click="openCreatePage(1)">创建索引</span>
            </div>
            <ul class="indLists">
              <li v-for="item in indLists" :key="item.value" class="clearfix">
                <ul class="indImgLists clearfix">
                    <img v-for="(item1, index) in item.indImgLists" :key="index" :src="item1" alt="" :class="[{'oneImg':item.imgNum == 1},{'twoImg':item.imgNum == 2 } ,{'threeImg':item.imgNum == 3} ,{'fourImg':item.imgNum == 4}]">
                </ul>
                <div class="indHeader">
                  <div class="clearfix">
                    <span class="indName">{{item.indexName}}</span>
                    <div class="iconBox">
                      <span class="indInfo" @click="openCreatePage(2,item)">索引详情</span>
                      <span>|</span>
                      <span class="indInfo" @click="openCreatePage(3,item)">索引编辑</span>
                      <span>|</span>
                      <span class="indInfo" @click="deleteRowMap(item, 3)">索引删除</span>
                    </div>
                  </div>
                  <p>
                    <span class="grayTxt">索引说明：</span>{{item.indexExplain}}
                  </p>
                  <p>
                    <span class="grayTxt">空间数据：</span>{{item.tblNamesStr}}
                  </p>
                </div>
              </li>
            </ul>
            <!-- <ul class="indLists">
              <li v-for="item in indLists" :key="item.value">
                <div class="indHeader clearfix">
                  <span class="indName">{{item.indexName}}</span>
                  <div class="iconBox">
                    <span class="indInfo" @click="openCreatePage(2,item)">索引详情</span>
                    <span>|</span>
                    <span class="indInfo" @click="openCreatePage(3,item)">索引编辑</span>
                    <span>|</span>
                    <span class="indInfo" @click="deleteRowMap(item, 3)">索引删除</span>
                  </div>
                </div>
                <p>
                  <span class="grayTxt">空间数据索引说明：</span>{{item.indexExplain}}
                </p>
                <el-table
                  :data="item.dataList"
                  :show-header="false"
                  style="width: 100%;">
                  <el-table-column
                    v-for="(meta, index) in item.metaList"
                    :key="index"
                    :prop="meta.metaName">
                  </el-table-column>
                </el-table>
              </li>
            </ul> -->
            <el-pagination
              @size-change="myIndexhandleSizeChange"
              @current-change="myIndexhandleCurrentChange"
              :current-page="myIndexCrtPage"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="myIndexSize"
              layout="sizes, prev, pager, next, jumper"
              :total="myIndexTotal">
            </el-pagination>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="40%">
      <el-form ref="form" :model="form" label-width="80px" :rules="rulesForm">
        <el-form-item label="选择数据/导入数据" label-width="140px" prop="chooseData">
          <el-select v-model="form.chooseData" placeholder="请选择数据" style="vertical-align: top;" multiple @change="chooseDataChange">
            <el-option v-for="item in chooseDataList" :key="item.id" :value="item.id" :label="item.showTableName" :disabled="item.disabled"></el-option>
          </el-select>
          <!-- <el-upload
            class="upload-demo"
            action="http://192.168.60.168:9529/oss/upload"
            :on-success="handleSuccess"
            :limit="1"
            ref="upload"
            style="display:inline-block;margin-left:10px;"
            accept=".jpg,.png">
            <el-button size="small" type="primary" class="blueBtn" @click="importMapData">导入地图数据</el-button>
          </el-upload> -->
          <el-button size="small" type="primary" class="blueBtn" @click="importMapData">导入地图数据</el-button>
        </el-form-item>
        <el-form-item label-width="140px">
          <img src="/images/photo01.png" alt="" style="width:140px;">
        </el-form-item>
        <el-form-item label="地图名称" label-width="140px" prop="serviceCname">
          <el-input v-model="form.serviceCname" placeholder="请输入地图名称"></el-input>
        </el-form-item>
        <el-form-item label="共享地图" label-width="140px" style="margin-bottom:10px;">
          <el-radio v-model="serviceType" label="02" style="margin-top:6px;">共享</el-radio>
          <el-radio v-model="serviceType" label="03" style="margin-left:-10px;">不共享</el-radio>
        </el-form-item>
        <el-form-item label="地图类别" label-width="140px" style="margin-bottom:10px;">
          <el-radio v-model="mapType" label="01" style="margin-top:6px;">地图服务</el-radio>
          <el-radio v-model="mapType" label="02" style="margin-left:-10px;">图层服务</el-radio>
        </el-form-item>
        <el-form-item label="地图标签" label-width="140px">
          <ul class="dialogLabelList clearfix">
            <li v-for="(item,index) in labelLists" :key="item.value" :class="{'mapLabel':true,'blueLable':item.ifBlueLabel}" @click="clickLabel(item.value,index)">
              {{item.value}}
            </li>
            <li :class="{'mapLabel':true,'blueLable':this.showOther}" @click="showOtherClick()">其他</li>
          </ul>
        </el-form-item>
        <el-form-item label-width="30px" style="display:inline-block">
          <el-input v-model="form.otherServiceFlag" v-if="showOther" style="width:300px; margin-left: -24px;" placeholder="请输入标签信息"></el-input>
        </el-form-item>
        <el-form-item label="地图说明" label-width="140px">
          <el-input v-model="form.remarks" placeholder="请输入地图说明" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="formSubmitBtn()" class="blueBtn">发布</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisibleEdit"
      width="40%">
      <el-form ref="editForm" :model="editData" label-width="80px">
        <!-- <el-form-item label="地图名称" label-width="140px">
          <el-input v-model="editData.serviceCname" placeholder="请输入地图名称"></el-input>
        </el-form-item> -->
        <el-form-item label="共享地图" label-width="140px" style="margin-bottom:10px;"  v-if="ifShowEdit">
          <el-radio v-model="editDataServiceType" label="02" style="margin-top:6px;">共享</el-radio>
          <el-radio v-model="editDataServiceType" label="03" style="margin-left:-10px;">不共享</el-radio>
        </el-form-item>
        <el-form-item label="地图类别" label-width="140px" style="margin-bottom:10px;">
          <el-radio v-model="editDataMapType" label="01" style="margin-top:6px;">地图服务</el-radio>
          <el-radio v-model="editDataMapType" label="02" style="margin-left:-10px;">图层服务</el-radio>
        </el-form-item>
        <el-form-item label="地图标签" label-width="140px">
          <ul class="dialogLabelList clearfix">
            <li v-for="(item,index) in labelLists" :key="item.value" :class="{'mapLabel':true,'blueLable':item.ifBlueLabel}" @click="clickLabel(item.value,index)">
              {{item.value}}
            </li>
            <li :class="{'mapLabel':true,'blueLable':this.showOther}" @click="showOtherClick()">其他</li>
          </ul>
        </el-form-item>
        <el-form-item label-width="30px" style="display:inline-block">
          <el-input v-model="editData.otherServiceFlag" v-if="showOther" style="width:300px; margin-left: -24px;" placeholder="请输入标签信息"></el-input>
        </el-form-item>
        <el-form-item label="地图说明" label-width="140px">
          <el-input v-model="editData.remarks" placeholder="请输入地图说明" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="formEditSubmit()" class="blueBtn">保存</el-button>
        <el-button @click="formEditClose()">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisibleSee"
      width="40%">
      <el-form ref="editForm" :model="editData" label-width="80px">
        <!-- <el-form-item label="地图名称" label-width="140px">
          <el-input v-model="editData.serviceCname" placeholder="请输入地图名称"></el-input>
        </el-form-item> -->
        <el-form-item label="共享地图" label-width="140px" style="margin-bottom:10px;" v-if="ifShowSee">
          <el-radio v-model="editDataServiceType" label="02" style="margin-top:6px;" :disabled="true">共享</el-radio>
          <el-radio v-model="editDataServiceType" label="03" style="margin-left:-10px;" :disabled="true">不共享</el-radio>
        </el-form-item>
        <el-form-item label="地图类别" label-width="140px" style="margin-bottom:10px;">
          <el-radio v-model="editDataMapType" label="01" style="margin-top:6px;" :disabled="true">地图服务</el-radio>
          <el-radio v-model="editDataMapType" label="02" style="margin-left:-10px;" :disabled="true">图层服务</el-radio>
        </el-form-item>
        <el-form-item label="地图标签" label-width="140px">
          <ul class="dialogLabelList clearfix">
            <li v-for="(item) in labelLists" :key="item.value" :class="{'mapLabel':true,'blueLable':item.ifBlueLabel}" >
              {{item.value}}
            </li>
            <li :class="{'mapLabel':true,'blueLable':this.showOther}" >更多</li>
          </ul>
        </el-form-item>
        <el-form-item label-width="30px" style="display:inline-block">
          <el-input v-model="editData.otherServiceFlag" v-if="showOther" :disabled="true" style="width:300px; margin-left: -24px;" placeholder="请输入标签信息"></el-input>
        </el-form-item>
        <el-form-item label="地图说明" label-width="140px">
          <el-input v-model="editData.remarks" placeholder="请输入地图说明" type="textarea" :disabled="true"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleSee = false">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="'删除' + deleteTitle"
      class='deleteDialog'
      :visible.sync="dialogVisibleDelete"
      width="40%">
      <div>是否删除当前{{deleteTitle}}?</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureDelete" class="blueBtn">确定</el-button>
        <el-button @click="dialogVisibleDelete = false">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="空间数据编辑"
      :visible.sync="sptlTblEditDialogVisible"
      width="40%">
      <el-form ref="sptlTblEditForm" :model="sptlTblEditData" label-width="80px">
        <el-form-item label="空间表名" label-width="140px">
          <el-input v-model="sptlTblEditData.showTableName" placeholder="请输入空间表名" @input="change"></el-input>
        </el-form-item>
        <el-form-item label="空间数据说明" label-width="140px">
          <el-input v-model="sptlTblEditData.instruction" placeholder="请输入空间数据说明" type="textarea" @input="change"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sptlTblSave" class="blueBtn">保存</el-button>
        <el-button @click="sptlTblEditDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="空间数据编辑"
      class="spaceDataInDialog"
      :visible.sync="spaceDataInDialog"
      width="80%">
      <import-space-data v-if="showTermFour" v-on:backPersonal="backPersonal"></import-space-data>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sptlTblSave" class="blueBtn">保存</el-button>
        <el-button @click="spaceDataInDialog = false">取消</el-button>
      </span> -->
    </el-dialog>

    <el-dialog
      title="新建切片"
      :visible.sync="addTile"
      width="60%">
        <el-form ref="addTileForm" :model="addTileData" label-width="80px">
        <el-form-item label="比例尺：" prop="types" label-width="120px" style="display:inline-block">
            <el-select v-model="addTileData.minLevel" size="mini">
              <el-option
              v-for="(item,index) in levelList"
              :key="index"  
              :label="item.label"
              :value="item.value"
              ></el-option> 
            </el-select>
            <span>-</span>
            <el-select v-model="addTileData.maxLevel" size="mini">
              <el-option
              v-for="(item,index) in levelList"
              :key="index"  
              :label="item.label"
              :value="item.value"
              ></el-option> 
            </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addTileSubmit" class="blueBtn">保存</el-button>
        <el-button @click="addTile = false">取消</el-button>
      </span>
    </el-dialog>

  </div>
</template>
 
<script>
import createIndex from '@/views/components/createIndex'
import mapLists from '@/views/components/mapLists'
import importSpaceData from '@/views/components/importSpaceData'
import sapceDataDetail from '@/views/components/sapceDataDetail'
// 使用配置文件的VUE_APP_DR_URL作为axios的基础地址
import request from '@/utils/request'
import {Loading} from 'element-ui';

import common from './../../../public/arcgisjs/common.js';
// 导入esri-loader（地图渲染）
import esriLoader from "esri-loader";
import { loadCss } from "esri-loader";
export default {
  name: 'personal',
  components:{
    createIndex,
    mapLists,
    importSpaceData,
    sapceDataDetail
  },
  data(){
    var validateService = (rule, value, callback) => {
      if (typeof(value) == 'undefined' || value.trim() != value) {
        callback(new Error('请填写服务名称且不包含空格'));
      }
      if (this.checkServiceCname(value)>=1) {
        callback(new Error('服务名已存在'));
      }
      callback(); 
    };
    return {
      spaceDataInDialog:false,
      deleteTitle:'',
      dialogVisibleDelete:false,
      dialogVisibleEdit:false,
      dialogVisibleSee:false,
      addTile:false,
      ifShowEdit:true,
      ifShowSee:true,
      showOther:false,
      clickBtnObj:{}, 
      form:{}, 
      addTileData:{},
      levelList:[], 
      rulesForm:{
          chooseData: [
            {required: true, message: '请选择数据', trigger: 'change' }
          ],
          serviceCname: [
            {validator:validateService, required: true, trigger: 'change' } 
          ]
      },
      editData:{},
      serviceType:"02",
      mapType:"01",
      editDataServiceType:"02",
      editDataMapType:"01",
      chooseDataList:[],
      dialogVisible:false,
      title:"",
      myMapCrtPage:1,
      myMapSize:10,
      myMapTotal:0,
      mydataCrtPage: 1,
      mydataSize: 10,
      mydataTotal:0,
      myIndexCrtPage: 1,
      myIndexSize: 10,
      myIndexTotal:0,
      dataCount:0,
      dataSum:0,
      mapCount:0,
      indCount:0,
      dataSize:150,
      mapSize:150,
      indSize:150,
      id:'',
      userName:'admin',
      activeName:'first',
      pointLists:[],
      myData:'',
      myIndex:'',
      navList:[
        {url1:'../../images/photo10.png',value:1,name:'首页',isActive:false},
        // {url1:'../../images/photo11.png',url2:'../../images/photo11-1.png',value:2,name:'地图',isActive:false},
        {url1:'../../images/photo12.png',url2:'../../images/photo12-1.png',value:3,name:'用户中心',isActive:true}
      ],
      mapListArrs:[],
      dataLists:[],
      indLists: [],
      remarks:[
        {value:'农业'},
        {value:'农险'},
        {value:'湖北人保'}
      ],
      labelLists:[
        {value:'交通',ifBlueLabel:false},
        {value:'农业',ifBlueLabel:false},
        {value:'行政区划',ifBlueLabel:false},
        {value:'医疗',ifBlueLabel:false},
        {value:'车辆网',ifBlueLabel:false}
      ],
      mapStates:[
        {value:'已发布',sty:'stateOne'},
        {value:'已切片',sty:'stateTwo'},
        {value:'未共享',sty:'stateThree'}
      ],
      serviceStatusLists:[
        {"01":"已发布"},
        {"02":"停止"},
        {"03":"正在发布"},
        {"04":"发布失败"}
      ],
      tileStatusLists:[
        {"0":"未切片"},
        {"1":"进行中"},
        {"2":"已切片"},
        {"3":"失败"}
      ],
      serviceTypeLists:[
        {"01":"公共"},
        {"02":"共享"},
        {"03":"个人"}
      ],
      serviceFlagList:[

      ],

     
      mapTypeLists:[
        {"01":"地图"},
        {"02":"图层"}
      ],

      showTermOne:true,
      showTermTwo:false,
      showTermThree:false,
      showTermFour:false,
      showTermFive:false,
      sptlTblInfo:{},
      paneName:'first',
      witchDelete:1,
      deleteData:'',
      mapPublishSkip: false,
      sptlTblEditDialogVisible: false,
      sptlTblEditData:{}
    }
  },
  created(){
    this.getServiceStatusDict();
    this.getTileStatusDict();
    this.getserviceTypeDict();
    this.getmapTypeDict();
    this.setLocalUserInfo();
    this.getMyMapList();
  },
  mounted(){
    // this.drawLine();
    this.drawLine2();

    // 加载CSS
    loadCss('/arcgisjs/arcgis_js_api/4.12/dijit/themes/claro/claro.css');
    loadCss('/arcgisjs/arcgis_js_api/4.12/esri/css/main.css');
    common.appConfig = common.getConfig();
    window.common = common;
    const esriOptions = {
      url: "/arcgisjs/arcgis_js_api/4.12/init.js",
      dojoConfig:{
        parseOnLoad: true,
        async: true,
        packages: [{ 
          name: '',
          location: ""
        }] 
      }
    }
    this.$nextTick(() => {
      if (!esriLoader.isLoaded()) {
        esriLoader.loadScript(esriOptions);
      }
    })
  },
  methods:{
    // 数据字典：服务状态
    getServiceStatusDict(){
      request({url:'/admin/dict/getDictItems?code=serviceStatus', method:'post' })
        .then(res => {
          if (res.data.code == 200) {
            let map = new Map([]);
            for(let key in res.data.data){
              map.set(key, res.data.data[key]);
            }
            this.serviceStatusLists = map;
          }
        }).catch(error => {
          console.log(error)
        })
    },
    // 数据字典：瓦片状态
    getTileStatusDict(){
      request({url:'/admin/dict/getDictItems?code=TileStatus', method:'post' })
        .then(res => {
          if (res.data.code == 200) {
            let map = new Map([]);
            for(let key in res.data.data){
              map.set(key, res.data.data[key]);
            }
            this.tileStatusLists = map;
          }
        }).catch(error => {
          console.log(error)
        })
    },
    // 数据字典：地图类型
    getserviceTypeDict(){
      request({url:'/admin/dict/getDictItems?code=serviceType', method:'post' })
        .then(res => {
          if (res.data.code == 200) {
            let map = new Map([]);
            for(let key in res.data.data){
              map.set(key, res.data.data[key]);
            }
            this.serviceTypeLists = map;
          }
        }).catch(error => {
          console.log(error)
        })
    },
    
    getmapTypeDict(){
      request({url:'/admin/dict/getDictItems?code=mapType', method:'post' })
        .then(res => {
          if (res.data.code == 200) {
            let map = new Map([]);
            for(let key in res.data.data){
              map.set(key, res.data.data[key]);
            }
            this.mapTypeLists = map;
          }
        }).catch(error => {
          console.log(error)
        })
    },

    getserviceFlagDict(){
      request({url:'/admin/dict/getDictItems?code=serviceFlag', method:'post' })
        .then(res => {
          if (res.data.code == 200) {
            let map = new Map([]);
            for(let key in res.data.data){
              map.set(key, res.data.data[key]);
            }
            this.serviceFlagLists = map;
          }
        }).catch(error => {
          console.log(error)
        })
    },


    /**
     * 地图发布弹出框，点击“导入地图数据”，跳转到空间数据入库界面
     */
    importMapData() {
      this.dialogVisible = false;
      // 空间数据入库返回时，跳出发布地图弹出框
      this.mapPublishSkip = true;
      this.importSpaceData();
    },
    /**
     * 删除空间表
     */
    deleteSptlTbl() {
      var deleteSptlTblLoading = Loading.service({
        target:'#mySptlData',
        lock: true,
        text: '空间数据正在删除中',
        // background: 'rgba(0, 0, 0, 0.7)'
      });
      var params = {
        importType: this.deleteData.importType,
        tableName: this.deleteData.itableName,
        username: JSON.parse(localStorage.getItem('portalUserName')),
        dbClassify: this.deleteData.databaseType,
        importId: this.deleteData.value
      };
      return new Promise((resolve, reject) => {
        request({url:'/portal/mydata/spatialdata/deleteSpatialTbl', method:'post' ,params:params, timeout: 1000 * 60 * 1})
        .then(response => {
          deleteSptlTblLoading.close();
          if (response.data.code == 201) {
            this.$message.success(response.data.msg);
            // 删除成功，刷新我的数据列表
            this.loadMydataList();
          }
          resolve(response.data)
        }).catch(error => {
          deleteSptlTblLoading.close();
          reject(error)
        })
      })
    },
    /**
     * 删除本地索引信息
     */
    deleteSptlIndex() {
      var deleteSptlIndexLoading = Loading.service({
        target:'#mySptlIndex',
        lock: true,
        text: '空间数据索引正在删除中',
        // background: 'rgba(0, 0, 0, 0.7)'
      });
      var params = {
        indexId: this.deleteData.value
      };
      return new Promise((resolve, reject) => {
        request({url:'/portal/myindex/indexDel', method:'post' ,params:params, timeout: 1000 * 60 * 1})
        .then(response => {
          deleteSptlIndexLoading.close();
          if (response.data.code == 200 || response.data.code == 201) {
            // 删除本地索引信息成功，删除ES上索引
            this.$message.success('索引删除成功');
            this.deleteEsIndex(this.deleteData.value);
            // 刷新页面
            this.loadMyIndexList();
          }
          resolve(response.data)
        }).catch(error => {
          deleteSptlIndexLoading.close();
          reject(error)
        })
      })
    },

    /**
     * 删除ES上索引
     */
    deleteEsIndex(indexId) {
      var params = {
        indexId: indexId
      };
      return new Promise((resolve, reject) => {
        request({url:'/portal/myindex/delESSpatialIndex', method:'post' ,params:params, timeout: 1000 * 60 * 1})
        .then(response => {
          // resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
      //服务删除
      deleteService(val){
        request({url:'/portalmap/myserver/gisMapManager/delete?serviceId='+val,method:'post',timeout: 1000 * 60 * 1})
        .then(res=>{
          if(res.data.code=="200"){ 
            this.$message({
              message: "操作成功",
              type: 'success'
            }) 
            this.mapListArrs = [];
            this.getMyMapList();
          }else{
            this.$message({
              message: "操作失败",
              type: 'error'
            })
          }
        }).catch(error=>{
          this.$message({
            message: "操作失败",
            type: 'error'
          })
        })
      },

    //确认删除按钮
    sureDelete(){
      // alert(this.witchDelete)
      // 隐藏删除确认框
      this.dialogVisibleDelete = false;
      if(this.witchDelete == 1){ 
          //删除地图接口
        this.deleteService(this.deleteData); 
      }else if(this.witchDelete == 2){
          //删除数据接口
          this.deleteSptlTbl();
      }else if(this.witchDelete == 3){
          //删除索引接口
          this.deleteSptlIndex();
      }

    },
    //删除我的地图
    deleteRowMap(val,num){
      if(num == 1){
        this.deleteTitle = '地图' 
      }else if(num == 2){
         this.deleteTitle = '数据'
      }else if(num == 3){
         this.deleteTitle = '索引'
      }
      this.deleteData = val;
      this.witchDelete = num;
      this.dialogVisibleDelete = true;
    },
    // 查看我的地图(不可修改)
    seeRowMap(val){
      let param = {};
      param.id = val;
      this.dialogVisibleSee = true;
      this.showOther = false;
      this.editData = {};
      request({url:'/portalmap/gisServerController/findMapInfoById', method:'post', data:param })
      .then(res => {
        this.title = "查看地图";
        this.editData = res.data.data;
        // 公共地图不修改是否共享
        if(this.editData.serviceType == "01"){
          this.ifShowSee = false;
        } else {
          this.ifShowSee = true;
        }
        this.editDataServiceType = this.editData.serviceType;
        this.editDataMapType = this.editData.mapType;
        // 地图标签处理
        if(this.editData.serviceFlag != null) {
          let serviceFlagArr = this.editData.serviceFlag.split(';');
          this.labelLists.forEach(v => {
            // 筛选出‘其他’地图标签
            for (let i = 0; i < serviceFlagArr.length; i++) {
            const arr = serviceFlagArr[i];
              if(v.value == arr){
                serviceFlagArr.splice(i, 1)
                i-=1;
              }
            }
            // 设置已选标签高亮
            if(this.editData.serviceFlag.indexOf(v.value) != -1){
              v.ifBlueLabel = true;
            } else {
              v.ifBlueLabel = false;
            }
          })
          // 显示‘其他’地图标签
          if(serviceFlagArr.length > 0) {
            this.$set(this.editData, 'otherServiceFlag', serviceFlagArr[0])
            this.showOther = true;
          }
        }
      })
      .catch(err => {
        console.log(err);
      })
    },
    // 修改我的地图
    editRowMap(val){
      let param = {};
      param.id = val;
      this.dialogVisibleEdit = true;
      this.showOther = false;
      this.editData = {};
      request({url:'/portalmap/gisServerController/findMapInfoById', method:'post', data:param })
      .then(res => {
        this.title = "地图编辑";
        this.editData = res.data.data;

        this.editDataServiceType = this.editData.serviceType;
        // 如果是公共地图，则不显示 共享/不共享 的按钮
        // if(this.editData.serviceType == '01'){
        //   this.ifShowEdit = false;
        // } else {
        //   this.ifShowEdit = true;
        // }
        this.editDataMapType = this.editData.mapType;
        // 地图标签处理
        if(this.editData.serviceFlag != null) {
          let serviceFlagArr = this.editData.serviceFlag.split(';');
          this.labelLists.forEach(v => {
            // 筛选出‘其他’地图标签
            for (let i = 0; i < serviceFlagArr.length; i++) {
            const arr = serviceFlagArr[i];
              if(v.value == arr){
                serviceFlagArr.splice(i, 1)
                i-=1;
              }
            }
            // 设置已选标签高亮
            if(this.editData.serviceFlag.indexOf(v.value) != -1){
              v.ifBlueLabel = true;
            } else {
              v.ifBlueLabel = false;
            }
          })
          // 显示‘其他’地图标签
          if(serviceFlagArr.length > 0) {
            this.$set(this.editData, 'otherServiceFlag', serviceFlagArr[0])
            this.showOther = true;
          }
        }
      })
      .catch(err => {
        console.log(err);
      })
    },
    formEditClose(){
      this.dialogVisibleEdit = false;
      // 清除修改参数
      this.editData = {};
      this.editDataServiceType="02";
      this.editDataMapType="01";
      this.labelLists.forEach((v)=>{
        v.ifBlueLabel = false;
      });
    },
    // 确认修改保存
    formEditSubmit() {
      this.editData.serviceType = this.editDataServiceType;
      this.editData.mapType = this.editDataMapType;
      this.editData.serviceFlag = "";
      this.labelLists.forEach((v)=>{
        if(v.ifBlueLabel){
          this.editData.serviceFlag+=v.value+";"
        }
      });
      // 如果选择了‘其他’标签，则追加其他标签到标签中
      if(this.showOther && this.editData.otherServiceFlag){
        this.editData.serviceFlag += this.editData.otherServiceFlag + ";";
      }
      this.editData.serviceFlag = this.editData.serviceFlag.substr(0,this.editData.serviceFlag.length-1);

      // 修改
      request({url:'/portalmap/gisServerController/modifyMapInfo', method:'post', data:this.editData })
      .then(res => {
        if(res.data.code == "200"){
          this.$message({
            message: res.data.msg,
            type: 'success'
          })
          this.formEditClose();
          this.mapListArrs = [];
          this.getMyMapList();
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          });
        }
      })
      .catch(err => {
        console.log(err);
      })
      this.dialogVisibleEdit = false;
    },
    //获取我的地图列表数据
    getMyMapList(){
      request({url:'/portalmap/gisServerController/findmy?currentPage=' + this.myMapCrtPage + '&size=' + this.myMapSize, method:'post'})
      .then(res => {
        this.mapListArrs = res.data.data.records.concat();
        this.myMapTotal = res.data.data.total;
        console.log(this.mapListArrs)
        this.mapListArrs.forEach((v,i) => {
          if(v.thumbnail == null){
            v.thumbnail = './../../images/photo06.png'
          }
          v.mapStates = [];
          // 服务状态显示文字
          let text1 = this.serviceStatusLists.get(v.serviceStatus.toString());
          // 已发布
          if('01' == v.serviceStatus.toString()){
            v.mapStates.push({value:text1,sty:'stateOne'})
          }else{
            v.mapStates.push({value:text1,sty:'stateGray'})
          }

          // 瓦片状态显示文字
          let text2 = this.tileStatusLists.get(v.status.toString());
          // 已切片
          if('2' == v.status.toString()){
            if(v.isTileUpdate > 0){
              v.mapStates.push({value:text2,sty:'stateUpdate'})
            }else{
              v.mapStates.push({value:text2,sty:'stateTwo'})
            }
            
          }else{
            v.mapStates.push({value:text2,sty:'stateGray'})
          }
          
          // 地图类型显示文字
          let text3 = this.serviceTypeLists.get(v.serviceType.toString());
          // 01公共 02共享 03私人
          if('01' == v.serviceType.toString()){
            v.mapStates.push({value:text3,sty:'stateTwo'})
          }
          if('02' == v.serviceType.toString()){
            v.mapStates.push({value:'已共享',sty:'stateTwo'})
          }
          if('03' == v.serviceType.toString()){
            v.mapStates.push({value:'未共享',sty:'stateGray'})
          }

          // 地图类别
          v.mapTypeText = this.mapTypeLists.get(v.mapType.toString());
             
          if(v.serviceFlag != null && v.serviceFlag.length > 1){
            let flagArr = v.serviceFlag.split(';');
            v.serviceflagArr = [];
            flagArr.forEach((v2,i2) => {
              v.serviceflagArr.push({value:v2})
            })
          }

        })
        
      })
      .catch(err => {
        console.log(err);
      })
    },

    checkServiceCname(val){
      request({url:'/portalmap/gisServerController/check?serviceCname='+val,method:'post'})
        .then(res => {
          if(res.data.code=="200"){ 
              return res.data.data
          }
          return 0
        })
        .catch(err => {
          return 0
        }) 
    },
    //地图发布保存
    formSubmitBtn(){
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
              this.form.sourceArr = [];
              // 多选框的选中值写入form (type、lable)
              this.form.chooseData.forEach((val) => {
                this.chooseDataList.forEach((val2) => {
                  if(val == val2.id){
                    this.form.serviceCategory=val2.type;
                    this.form.sourceArr.push(val2.id); // 改为传id (2019.12.31更改)
                    // if(val2.type==2){
                    //   this.form.sourceArr.push(val2.fileUrl);
                    // } else {
                    //   this.form.sourceArr.push(val2.lable);
                    // }
                  }
                })
              })
              
              this.form.serviceFlag="",
              this.form.serviceType=this.serviceType,
              this.form.mapType=this.mapType,
              
              this.labelLists.forEach((v)=>{
                if(v.ifBlueLabel){
                  this.form.serviceFlag+=v.value+";"
                }
              });
              // 如果选择了‘其他’标签，则追加其他标签到标签中
              if(this.showOther && this.form.otherServiceFlag){
                this.form.serviceFlag += this.form.otherServiceFlag + ";";
              }
              this.form.serviceFlag = this.form.serviceFlag.substr(0,this.form.serviceFlag.length-1);

              request({url:'/portalmap/myserver/gisMapManager/publish',method:'post',data:this.form})
              .then(res => { 
                if(res.data.code=="200"){ 
                  this.$message({
                    message: res.data.msg,
                    type: 'success'
                  })
                  // 发布提交成功后关闭弹窗
                  this.dialogVisible = false
                  this.mapListArrs = [];
                  this.getMyMapList()
                }else{
                  this.$message({
                    message: res.data.msg,
                    type: 'error'
                  })
                }
              })
              .catch(err => {
                  this.$message({
                    message: "操作失败",
                    type: 'error'
                  })
                console.log(err);
              }) 
          }).catch(()=>{})
        }
      })

      
    }, 
 
    //地图发布选择数据
    chooseDataChange(val){
      this.chooseDataList.forEach((v1,i1) => {
        this.form.chooseData.forEach((v2,i2) => {
          if(v2 == v1.id){
              if(v1.type == 2){
                this.chooseDataList.forEach((v3,i3) => {
                  v3.disabled = true;
                })
                v1.disabled = false;
              }
                  
              if(v1.type == 1){
                v1.disabled = false;
                this.chooseDataList.forEach((v4,i4) => {
                  if(v4.type == 2){
                    // 选了shp就不可选tif
                    v4.disabled = true;
                  }else{
                    // 只能选同坐标系的数据
                    if(v1.epsg == v4.epsg){
                        v4.disabled = false
                    }else{
                        v4.disabled = true
                    }
                  }
                })
              }
          }
        })

        if(this.form.chooseData.length == 0){
          v1.disabled = false;
        }
      })
    },
    // 展示空间数据详情
    showSptlDetail(tblInfo) {
      this.sptlTblInfo = tblInfo;
      this.backHome();
    },
    // 加载地图
    initMap(tblId, itableName){
      // 加载的顺序不能混乱，比如"esri/map"在第一，Map就要在第一
      esriLoader.loadModules([
        "esri/Map", 
        "esri/layers/GeoJSONLayer",
        "esri/views/MapView"
      ])
      .then(([
        Map, 
        GeoJSONLayer,
        MapView
      ]) => {
        const url = "/portal/mydata/spatialdata/getGeoJSON?tableName=" + itableName;
        
        const geojsonLayer = new GeoJSONLayer({
          url: url,
          copyright: "USGS Earthquakes"
        });

        const map = new Map({
          // basemap: "gray",
          layers: [geojsonLayer]
        });

        const view = new MapView({
          container: "map-main" + tblId,
          center: [-168, 46],
          zoom: 5,
          map: map
        });
        view.ui.components = [];//清空所有ESRI自带的组件（包括logo、放大缩小按钮）
        // 禁用：鼠标双击事件
        view.on('double-click',function(e){
          e.stopPropagation()
        })
        // 禁用：鼠标拖拽事件
        view.on('drag',function(e){
          e.stopPropagation()
        })
        // 禁用：键盘按下时事件
        view.on('key-down',function(e){
          e.stopPropagation()
        })
        // 禁用：鼠标滚轮事件事件
        view.on('mouse-wheel',function(e){
          e.stopPropagation()
        })

        // geojsonLayer.when(function(){
        //   view.extent = geojsonLayer.fullExtent;
        // });
        geojsonLayer.queryExtent(geojsonLayer.createQuery()).then(function(results){
          view.goTo(results.extent);  // go to the extent of the results satisfying the query
        });

      })
    },
    setLocalUserInfo(){
      this.id = JSON.parse(localStorage.getItem('portalUserId'));
      this.userName = JSON.parse(localStorage.getItem('portalUserName'));

      // 用户数据统计和地图统计
      this.getDateAndMapCount();
      // 用户索引统计
      this.getIndexCount();
      //用户上传文件总大小
      this.getdataSum();
    },
    getIndexCount() {
      var params = {
        username: this.userName
      };
      return new Promise((resolve, reject) => {
        request({url:'/portal/myindex/count', method:'post' ,params:params, timeout: 1000 * 60 * 1})
        .then(response => {
          this.myIndexTotal = response.data.data;
          this.indCount = response.data.data;
          this.drawLine2();
          // 更新页面总数
          // this.myIndex = '我的索引 ('+ this.myIndexTotal +')';
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    
    // 强制更新视图，解决input无法输入的问题
    change(event) {
      this.$forceUpdate();
    },
    /**
     * 空间数据编辑按钮点击事件
     */
    spaceDataEdit(tblInfo){
      this.sptlTblEditData.showTableName = tblInfo.showTableName;
      this.sptlTblEditData.instruction = tblInfo.instruction;
      this.sptlTblEditData.id = tblInfo.value;
      // 显示空间数据编辑弹出框
      this.sptlTblEditDialogVisible = true;
    },
    /**
     * 空间数据编辑保存
     */
    sptlTblSave() {
      this.sptlTblEditDialogVisible = false;
      var sptlSaveLoading = Loading.service({
        target:'#mySptlData',
        lock: true,
        text: '正在保存空间数据',
        // background: 'rgba(0, 0, 0, 0.7)'
      });
      var params = {
        id: this.sptlTblEditData.id,
        showTableName: this.sptlTblEditData.showTableName,
        instruction: this.sptlTblEditData.instruction
      };
      return new Promise((resolve, reject) => {
        request({url:'portal/mydata/spatialdata/save', method:'post' ,data:params, timeout: 1000 * 60 * 1})
        .then(response => {
          sptlSaveLoading.close();
          if (response.data.code == 201 || response.data.code == 200) {
            this.$message.success('保存成功');
            this.loadMydataList();
          }
          resolve(response.data)
        }).catch(error => {
          sptlSaveLoading.close();
          reject(error)
        })
      })
    },
    //返回首页
    backHome(){
      this.showTermOne = false;
      this.showTermTwo = false;
      this.showTermThree = false;
      this.showTermFour = false;
      this.showTermFive = true;
      // this.$router.push({path:'/'})
    },
    //导入空间数据
    importSpaceData(){
      this.spaceDataInDialog = true;
      // this.showTermOne = false;
      this.showTermTwo = false;
      this.showTermThree = false;
      this.showTermFour = true;
      this.showTermFive = false;
    },
    //从创建索引返回个人中心
    backPersonal(val,data){
      this.spaceDataInDialog = false;
      if(val){
        this.refreshPersonal();
      }
    },
    //创建索引,编辑索引,索引详情
    openCreatePage(ind,item){
      this.clickBtnObj.ind = ind;
      if (item != undefined && item != null) {
        this.clickBtnObj.val = item.value;
      }
      this.showTermOne = false;
      this.showTermTwo = true;
      this.showTermThree = false;
      this.showTermFour = false;
      this.showTermFive = false;
    },
    //返回个人中心刷新页面
    refreshPersonal(){
      this.showTermOne = true;
      this.showTermTwo = false;
      this.showTermThree = false;
      this.showTermFour = false;
      this.showTermFive = false;
      if (this.paneName == 'second') {
        this.loadMydataList();
      }
      if (this.paneName == 'third') {
        this.loadMyIndexList();
      }
      // 弹出地图发布框
      if (this.mapPublishSkip) {
        this.mapPublishSkip = false;
        this.mapPublish();
      }
      this.$nextTick(() => {
        this.drawLine();
        this.drawLine1();
        this.drawLine2();
      })
    },
    //点击导航
    changeNav(val){
      if(val == 0){
        this.$router.push({path:'/'});
        return false;
      // }else if(val == 1){
      //   this.showTermOne = false;
      //   this.showTermTwo = false;
      //   this.showTermThree = true;
      //   this.showTermFour = false;
      //   this.showTermFive = false;
      }else if(val == 1){
        this.refreshPersonal();
      }
      this.navList.forEach((v,i) => {
        if(val == i){
          v.isActive = true;
        }else{
          v.isActive = false;
        }
      })
    },
    myMaphandleSizeChange(val){
      this.myMapSize = val;
      this.getMyMapList();
    },
    myMaphandleCurrentChange(val){
      this.myMapCrtPage = val;
      this.getMyMapList();
    },
    myIndexhandleSizeChange(val) {
      this.myIndexSize = val;
      this.loadMyIndexList();
    },
    myIndexhandleCurrentChange(val) {
      this.myIndexCrtPage = val;
      this.loadMyIndexList();
    },
    mydataHandleSizeChange(val) {
      this.mydataSize = val;
      this.loadMydataList();
    },
    mydataHandleCurrentChange(val) {
      this.mydataCrtPage = val;
      this.loadMydataList();
    },
    /**
     * 加载我的索引列表
     */
    loadMyIndexList() {
      var sptlIndexLoading = Loading.service({
        target:'#mySptlIndex',
        lock: true,
        text: '正在加载我的索引列表',
        // background: 'rgba(0, 0, 0, 0.7)'
      });
      var params = {
        is_deleted: 0,
        createUser: JSON.parse(localStorage.getItem('portalUserName')),
        size: this.myIndexSize,
        current: this.myIndexCrtPage
      };
      return new Promise((resolve, reject) => {
        request({url:'/portal/myindex/find', method:'post' ,data:params, timeout: 1000 * 60 * 1})
        .then(response => {
          console.log(response)
          sptlIndexLoading.close();
          this.myIndexTotal = response.data.data.total;
          this.indCount = response.data.data.total;
          let resList = response.data.data.records.concat();
          // 先清空空间索引列表
          this.indLists = [];
          for (let i = 0; i < resList.length; i++) {
            var indexInfo = resList[i];
            // 索引配置信息列表
            var dataList = [];
            // 逻辑表名列表
            var tblNamesStr = '';
            // 缩略图列表
            var indImgLists = [];
            for (let j = 0; j < indexInfo.indexTblList.length;j++) {
              var indexTmp = indexInfo.indexTblList[j];
              tblNamesStr += indexTmp.tableLogicname;
              if (indexTmp.thumUrl != null && indexTmp.thumUrl != undefined && indexTmp.thumUrl.trim() != '') {
                indImgLists.push(indexTmp.thumUrl);
              } else {
                indImgLists.push('../../images/photo0' + (j + 1) + '.png');
              }
              if (j == 3) {
                tblNamesStr += '...';
                break;
              }
              if (j != indexInfo.indexTblList.length - 1) {
                tblNamesStr += ', ';
              }
            }
            var imgNum = indImgLists.length;
            if(imgNum > 4){
              imgNum = 4
            }
            var data = {
              value: indexInfo.id,
              indexName: indexInfo.indexLogicname,
              indexExplain: indexInfo.indexExplain,
              tblNamesStr: tblNamesStr,
              indImgLists: indImgLists,
              imgNum: imgNum
            }
            this.indLists.push(data);
          }
          resolve(response.data)
        }).catch(error => {
          sptlIndexLoading.close();
          reject(error)
        })
      })
    },
    /**
     * 加载“我的空间数据列表”
     */
    loadMydataList() {
      var sptlTblLoading = Loading.service({
        target:'#mySptlData',
        lock: true,
        text: '正在加载我的数据列表',
        // background: 'rgba(0, 0, 0, 0.7)'
      });
      var params = {
        is_deleted: 0,
        createUser: JSON.parse(localStorage.getItem('portalUserName')),
        size: this.mydataSize,
        current: this.mydataCrtPage
      };
      return new Promise((resolve, reject) => {
        request({url:'/portal/mydata/spatialdata/find', method:'post' ,data:params, timeout: 1000 * 60 * 1})
        .then(response => {
          console.log(response)
          sptlTblLoading.close();
          this.mydataTotal = response.data.data.total;
          // 更新页面我的数据总数
          this.dataCount = response.data.data.total;
          this.getdataSum();
          let resList = response.data.data.records.concat();
          // 先清空空间数据列表
          this.dataLists = [];
          var cycleNum = 0;
          for (let i = 0; i < resList.length; i++) {
            var tblInfo = resList[i];
            var data = {
              value: tblInfo.id,
              itableName: tblInfo.itableName,
              showTableName: tblInfo.showTableName,
              wktShortName: tblInfo.wktShortName,
              extent: '[' + tblInfo.minX + ',' + tblInfo.minY + ',' + tblInfo.maxX + ',' + tblInfo.maxY +  ']',
              minX: tblInfo.minX,
              minY: tblInfo.minY,
              maxX: tblInfo.maxX,
              maxY: tblInfo.maxY,
              layerType: tblInfo.layerType,
              databaseType: tblInfo.databaseType,
              sptlDataType: tblInfo.spatialdataType,
              instruction: tblInfo.instruction,
	      usageScope:tblInfo.usageScope,
              thumUrl: tblInfo.thumUrl,
              importType: tblInfo.importType,
              fileUrl: tblInfo.fileUrl
            }
            if (tblInfo.minX == undefined || tblInfo.minX == null) {
              data.extent = '';
            }
            if (data.thumUrl == undefined || data.thumUrl == null || data.thumUrl == '') {
              const imageNum = i - cycleNum * 4 + 6;
              data.thumUrl = "./../../images/photo06.png";
              // data.thumUrl = "../../images/photo0" + imageNum + ".png";
              // if ((cycleNum * 4 + 3) == i) {
              //   cycleNum += 1;
              // }
            }
            if(data.usageScope=='02'){
              data.usageScope='共享';
            }else if(data.usageScope=='03'){
              data.usageScope='个人';
            }else{
              data.usageScope='公共';
            }
            this.dataLists.push(data);
          }
          resolve(response.data)
        }).catch(error => {
          sptlTblLoading.close();
          reject(error)
        })
      })
    },
    handleSizeChange(val){
      this.size = val;
      this.getMyMapList();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getMyMapList();
    },
    //获取我的数据文件总大小（GB）
    getdataSum(){
      request({url:'/usercenter/sumFileSize',method:'post' })
      .then(res => {
          if(res.data.code == 200){
            // console.log(res.data.data);
            this.dataSum = res.data.data;
            this.drawLine();// 我的数据统计
          }else{
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
      })
      .catch(err => {
         console.log(err);
      })
    },
    getDateAndMapCount(){
      request({url:'/usercenter/countUserStldata',method:'post' })
      .then(res => {
          if(res.data.code == 200){
            this.dataCount = res.data.data;
            this.drawLine();// 我的数据统计
          }else{
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
      })
      .catch(err => {
         console.log(err);
      })
      request({url:'/usercenter/countUserMapdata',method:'post' })
      .then(res => {
          if(res.data.code == 200){
            this.mapCount = res.data.data;
            this.drawLine1();// 我的地图统计
          }else{
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
      })
      .catch(err => {
         console.log(err);
      })
    },
    //地图发布
    mapPublish(){
      // 获取下拉框数据
      this.spatialDataTree();
      this.title = '地图发布';
      this.form={};
      this.dialogVisible = true;
      this.showOther = false;
    },
    //解析方案
    getXmlParser(val){
      request({url:'/portalmap/myserver/gisMapManager/getXmlParser?serviceId='+val, method:'post'})
          .then(response=>{
            if(response.data.code == 200){ 
              this.levelList=[];
              for(let key in response.data.data){
                let obj={
                  label:key+" ： "+response.data.data[key],
                  value:key 
                };
                this.levelList.push(obj); 
              }
            }
          }).catch(error=>{
            this.levelList=[];
          }) 
    },

    // 新建切片提交
    addTileSubmit(){
      request({url:'/portalmap/myserver/gisMapManager/createTiles', method:'post',data:this.addTileData})
          .then(response=>{
            if(response.data.code == 200){ 
               this.$message({
                message: "操作成功",
                type: 'success'
               })
               this.getMyMapList()
               this.addTile = false;
            }else{
              this.$message({
                message: "操作失败",
                type: 'error'
               })
            }
          }).catch(error=>{
              this.$message({
                message: "操作失败",
                type: 'error'
               })
          }) 
      
    },
    //上传
    // handleSuccess(res){
    // },
    //点击标签
    clickLabel(val,i){
      this.labelLists[i].ifBlueLabel = !this.labelLists[i].ifBlueLabel; 
    },
    //退出登录
    signOut(){
      let userEntity = {};
      userEntity.id=this.id;
      userEntity.token = localStorage.getItem('portalToken');
      
      // 清除前台登录信息
      localStorage.removeItem('portalToken');
      localStorage.removeItem('portalUserId');
      localStorage.removeItem('portalUserName');

      // 清除后台登录信息
      request({url:'/usercenter/logout', method:'post', data: userEntity })
      .then(res => {
          if(res.data.code == 200){
            this.$message({
              message: res.data.data,
              type: 'success'
            })
          }else{
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
      })
      .catch(err => {
         console.log(err);
      })
      this.$router.push({path:'/'})
    },
    showDialog(val, item, index){
      if(index==0){// 发布状态
        alert(val)
      } 
      if(index==1){// 切片状态
        // 未切片
        if(val == this.tileStatusLists.get('0')){
          this.getXmlParser(item.id)
          this.addTileData={};
          this.addTileData.serviceId=item.id
          this.addTile = true;
        }else{
          alert(val)
        }
      }

      if(index==2){// 共享状态
        if(item.serviceType=="01"){
          // 点击公共
          alert(val)
        } else {
          this.$confirm('是否确认更改共享状态？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            showClose:false
          }).then(() => {
              // 02共享，03不共享
              item.serviceType = item.serviceType=="02"?"03":"02";
              request({url:'/portalmap/gisServerController/modifyMapInfo', method:'post', data:item })
              .then(res => {
                if(res.data.code == 200){
                  this.$message({
                    message: res.data.msg,
                    type: 'success'
                  })
                  // 刷新列表
                  this.mapListArrs = [];
                  this.getMyMapList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'warning'
                  });
                }
              })
              .catch(err => {
                console.log(err);
              })
          }).catch(err => {})
        }
      }
    },
    handleClick(tab, event) {
      if (tab.paneName == 'second') {
        this.paneName = 'second';
        this.loadMydataList();
      }
      if (tab.paneName == 'third') {
        this.paneName = 'third';
        this.loadMyIndexList();
      }
    },
    search(){},
    //返回个人中心
    personCenter(){},
    spatialDataTree(){
      request({url:'/portal/mydata/spatialdata/spatialDataTree', method:'post' })
      .then(res => {
          if(res.data.code == 200){
            this.chooseDataList = res.data.data;
          }else{
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
      })
      .catch(err => {
         console.log(err);
      })
    },
    drawLine(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'))
        // 绘制图表
        myChart.setOption({
            tooltip: {
                trigger: 'item',
                formatter: "{b}: {c} ({d}%)"
            },
            series: [{
                name: '个数',
                radius: ['70%', '90%'],
                center: ['35%', '60%'],
                type: 'pie',
                startAngle:180,
                // endAngle:340,
                capType: "round",
                label: {
                    normal: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        show: false,
                        textStyle: {
                            fontSize: '30',
                            fontWeight: 'bold'
                        }
                    }
                },
                labelLine: {
                    normal: {
                        show: false
                    }
                },
                data:[
                    {
                        name: '当前',
                        value: this.dataSum,
                        itemStyle: {
                            color: '#4da1ff'
                        }
                    },
                    {
                        name: '剩余',
                        value: this.dataSize - this.dataSum,
                        itemStyle: {
                            color: '#b9d7f7'
                        }
                    },
                    {
                        name: '总数',// 实际显示部分是总量-用量
                        value: this.dataSize,
                        itemStyle: {
                            color: 'transparent'
                        }
                    }
                ],
                // data: [this.dataCount, this.dataSize],
                itemStyle: {
                      
                      emphasis: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.3)'
                        },
                      normal:{
                        borderWidth:6,
                        shadowBlur: 30,
                        shadowColor: 'rgba(77,161,255,.3)', 
                        shadowOffsetX: -5,
                        shadowOffsetY: 5,
                          color:function(params) {
                          //自定义颜色
                          var colorList = [          
                                  '#4da1ff', '#b9d7f7',
                              ];
                              return colorList[params.dataIndex]
                            }
                      }
                }
            }]
        });
    },
    drawLine1(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart1'))
        // 绘制图表
        myChart.setOption({
            tooltip: {
                trigger: 'item',
                formatter: "{a} {b}: {c} ({d}%)"
            },
            series: [{
                name: '个数',
                radius: ['50%', '80%'],
                type: 'pie',
                label: {
                    normal: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        show: true,
                        textStyle: {
                            fontSize: '30',
                            fontWeight: 'bold'
                        }
                    }
                },
                labelLine: {
                    normal: {
                        show: false
                    }
                },
                data: [this.mapCount, this.mapSize],
                itemStyle: {
                      emphasis: {
                          shadowBlur: 10,
                          shadowOffsetX: 0,
                          shadowColor: 'rgba(0, 0, 0, 0.3)'
                        },
                      normal:{
                        shadowBlur: 30,
                        shadowColor: 'rgba(38,198,218,.3)', 
                        shadowOffsetX: -5,
                        shadowOffsetY: 5,
                          color:function(params) {
                          //自定义颜色
                          var colorList = [          
                                  '#1bcfcf', '#afecec',
                              ];
                              return colorList[params.dataIndex]
                            }
                      }
                }
            }]
        });
    },
    drawLine2(){
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart2'))
        // 绘制图表
        myChart.setOption({
            tooltip: {
              // position: ['50%', '50%'],
              // alwaysShowContent:true,
                trigger: 'axis',
                axisPointer: {
                  type: 'none'
                },
                formatter: "{a} : {c}/总数150"
            },
            xAxis:  {
                type: 'value',
                show:false
            },
            yAxis: {
                type: 'category',
                data: ['已发布'],
                show:false
            },
            series: [{
                name: '已发布',
                type: 'bar',
                stack: '总量',
                data: [this.indCount],
                barWidth : 8,
                itemStyle: {
                      normal:{
                        barBorderRadius:[10, 0, 0, 10],
                        shadowBlur: 30,
                        shadowColor: 'rgba(38,198,218,.3)', 
                        shadowOffsetX: -5,
                        shadowOffsetY: 5,
                          color:function(params) {
                          //自定义颜色
                          var colorList = [          
                                  '#87d068'
                              ];
                              return colorList[params.dataIndex]
                            }
                      }
                }
            },{
                name: '总数',
                type: 'bar',
                stack: '总量',
                data: [this.indSize],
                itemStyle: {
                      normal:{
                        barBorderRadius:[0, 10, 10, 0],
                        shadowBlur: 30,
                        shadowColor: 'rgba(38,198,218,.3)', 
                        shadowOffsetX: -5,
                        shadowOffsetY: 5,
                          color:function(params) {
                          //自定义颜色
                          var colorList = [          
                                  '#d5efca'
                              ];
                              return colorList[params.dataIndex]
                            }
                      }
                }
            }]
        });
    },
    //打开地图
    goMap(val){
      if(val.mapTypeText == '图层服务'){
        localStorage.setItem('mapNum',2);
      }else{
        localStorage.setItem('mapNum',1);
      }
      
      request({url:'/portalmap/gisServerController/visit?id='+val.id,method:'post'})
      this.$router.push({name:'map',query:val});
    },
    // 点击更多地图标签显示输入框
    showOtherClick(){
      if(this.showOther){
        this.showOther = false;
      } else {
        this.showOther = true;
      }
    },
  }
}
</script>

<style scoped>
#addTileConnector{margin-right: 16px; display: initial;}

.centerBox{width:100%;padding:80px 20px 20px 20px;}


.firstBox,.chartBox,.rightBox{border-radius:5px;box-shadow:0 0 30px #dae5f0;}
.leftBox{width:100%;padding:0;margin-bottom:20px;height:200px}
.rightBox{width:100%;padding:10px 0;}
.leftBox .photo{width:70px;}
.leftBox h4{margin:10px 0 8px;font-size:16px;}
.firstBox{padding:20px;}
.firstBox,.chartBox{float:left;width:32%;height:100%;}
.chartBox{position:relative;margin-right:2%;padding:20px 0 0 20px;}
.chartBox:last-child{margin-right:0;}
.dataBox{position:absolute;right:10%;top:70px;text-align:left;}

.jobName,.departName,.addressName{display:block;line-height:24px;text-align:left;font-size:12px;text-indent:25px;}
.jobName{background:url('../../assets/images/icon14.png') no-repeat 0 4px;background-size:14px;}
.departName{margin:10px 0;background:url('../../assets/images/icon19.png') no-repeat 0 4px;background-size:16px;}
.addressName{background:url('../../assets/images/icon15.png') no-repeat 0 4px;background-size:14px;}
.line{height:1px;margin:15px 0;border-bottom:1px solid #eee;}
.chartBox .title{height:16px;border-left:2px solid #4da1ff;text-align:left;text-indent:10px;line-height:16px;color:#4da1ff;font-size:14px;}
.bluePoint{width:8px;height:8px;border-radius:4px;background:#4da1ff}
.grayPoint{width:8px;height:8px;border-radius:4px;background:#b9d7f7}
.dataBox span{display:inline-block;margin:0 1px 0 5px;font-size:12px;color:#a1aac4}
.dataBox .bigTxt{font-size:20px;font-family:myfont;color:#526281;}
.personalBox >>> .el-tabs__nav-scroll{padding-left:20px!important;}
.mapLi{position:relative;padding:23px 20px;width:100%;box-sizing:border-box;border-bottom:1px solid #eee;}
.mapLi:last-child{border:0;}
.msgInfo,.mapImg{float:left;}
.mapImg{width:170px;min-height: 100px;}
.mapOperation{float:right}
.mapState{margin-top:10px;}
.mapState span,.mapState ul{vertical-align:top;display:inline-block;}
.mapState>span{margin-left:10px;}
.mapState li{float:left;cursor:pointer;margin-right:10px;}
.mapState .stateOne,.mapState .stateTwo,.mapState .stateThree,.mapState .stateGray{margin:0 1px;width:18px;height:18px}
.stateOne{background:url('../../assets/images/icon21.png') no-repeat 0 5px;background-size:64%}
.stateGray{background:url('../../assets/images/icon43.png') no-repeat 0 5px;background-size:64%}
.stateTwo{background:url('../../assets/images/icon22.png') no-repeat 0 5px;background-size:64%}
.stateUpdate{background:url('../../assets/images/icon48.png') no-repeat 0 5px;background-size:64%}
.stateThree{background:url('../../assets/images/icon23.png') no-repeat 0 5px;background-size:64%}
.msgInfo h4{color:#4da1ff;font-size:14px;}
.msgInfo{width:50%;margin-left:20px;line-height:20px;text-align:left;font-size:12px;color:#526281;}
.msgInfo p{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
/* .msgInfo p{text-overflow:ellipsis;overflow:hidden;} */
.dataInfo h4{margin-bottom:12px;}
.dataInfo{line-height:18px;}
.labelList li{line-height:18px;}
.dialogLabelList li{line-height:24px;}
.dialogLabelList .mapLabel{cursor:pointer;margin:0 10px 0 0;}
.mapLabel{float:left;padding:0 8px;margin:5px 5px 5px 0;border:1px solid #d8dff1;font-size:12px;background:#fafafa}
.grayTxt,.stateTime{color:#a1aac4}
.mapOperation span,.iconBox span{display:inline-block;cursor:pointer;margin:0 3px;font-size:12px;color:#eee;}
.mapOperation .deleteBtn{background:url('../../assets/images/icon17.png') no-repeat 0 2px;background-size:25%;text-indent:15px;color:#4da1ff}
.mapOperation .mapEdit,.mapOperation .dataEdit{background:url('../../assets/images/icon18.png') no-repeat 0 2px;background-size:18%;text-indent:16px;color:#4da1ff}
.mapOperation .dataEdit{background-size:14%;}

.btnBox{position:absolute;right:20px;top:-38px;z-index:100;text-align:right;background:linear-gradient(to bottom,#52bdff,#0084ff);border-radius:5px;color:#fff;}
.mapPublish,.dataIn,.createInd{cursor:pointer;display:inline-block;padding:6px 8px;font-size:12px;text-indent:16px;}
.mapPublish{background:url('../../assets/images/icon44.png') no-repeat 6px 8px;background-size:12px;color:#fff;}
.dataIn{background:url('../../assets/images/icon45.png') no-repeat 6px 8px;background-size:12px;color:#fff}
.createInd{background:url('../../assets/images/icon46.png') no-repeat 6px 8px;background-size:12px;color:#fff}

.personalBox >>> .el-tabs__nav-wrap::after{height:1px;}
.personalBox >>> .el-tabs__header{margin:0;}
.personalBox >>> .el-pagination{padding-right:80px;padding-top:20px;text-align:right;}
.personalBox >>> .el-tabs__content{overflow:visible;}

.personalBox >>> .el-pager li.active {
    color: #fff;
    cursor: default;
    /* background: #409EFF; */
    background:linear-gradient(to bottom,#52bdff,#0084ff);
}

.blueBtn{height:30px;line-height:10px;background:linear-gradient(to bottom,#52bdff,#0084ff);}
.blueLable{background:linear-gradient(to bottom,#52bdff,#0084ff);color:#fff;}
.personalBox >>> .el-upload-list{display:none;}
.personalBox >>> .el-form-item{margin-bottom:15px}
.personalBox >>> .el-form-item__content,.personalBox >>> .el-input__icon{line-height:0;text-align:left;}
.personalBox >>> .el-input__icon{text-align:center;}
.personalBox >>> .el-form-item__label{line-height:30px;color:#526281}
.personalBox >>> .el-dialog__header{padding:15px;border-bottom:1px solid #dbe0ef;text-align:left;}
.personalBox >>> .el-dialog__body{padding:15px 20px;}
.personalBox >>> .el-dialog__footer{padding:15px;border-top:1px solid #dbe0ef;}
.personalBox >>> .el-input__inner{height:30px;line-height:30px;border-color:#dbe0ef}
.personalBox >>> .el-button{padding:9px 15px;height:30px;}
.personalBox >>> .el-dialog__title{display:inline-block;background:url('../../assets/images/icon20.png') no-repeat 0 1px;text-indent:25px;color:#526281;font-size:16px;}
.personalBox >>> .el-dialog__headerbtn{top:15px;right:15px;font-size:18px}
.personalBox >>> .el-input,.personalBox >>> .el-textarea{width:94%}
.personalBox >>> .el-table__body{font-size:12px;}
.personalBox >>> .el-table__body td{padding:8px 0;color:#526281;text-align:center}
.personalBox >>> .el-table__body tr td:first-child{background:#fafafa;}
.personalBox >>> .el-table__body tr:first-child td{border-top:1px solid #EBEEF5;}
.personalBox >>> .el-tabs__item{color:#a1aac4}
.personalBox >>> .el-tabs__item:hover,.personalBox >>> .el-tabs__item.is-active{color:#409EFF}
.deleteDialog >>> .el-dialog__title{background:transparent;text-indent:0;}
.deleteDialog >>> .el-dialog__header,.deleteDialog >>> .el-dialog__footer {border:0;}

.indLists>li{padding: 23px 20px;border-bottom: 1px solid #eee;}
.indLists>li:last-child{border-bottom:0;}
.indLists p{margin:15px 0;text-align:left;font-size:12px;}
.indName{float:left;color:#4da1ff}
.iconBox{float:right;font-size:12px;}
.indInfo{background:url('../../assets/images/icon25.png') no-repeat 0 3px;}

.iconBox .indInfo{display:inline-block;background-size:18%;text-indent:15px;color:#4da1ff}
.spaceDataInDialog >>> .el-dialog{margin-top:10px!important;margin-bottom:0!important}
.spaceDataInDialog >>> .el-dialog .el-dialog__header{display:none;}

.indImgLists,.indHeader{float:left;}
.indImgLists{width:14%;height:120px;overflow:hidden;}
.indHeader{width:84%;margin-left:1%;}

.indImgLists img{float:left;margin:1%;box-sizing:border-box;}
.oneImg{width:100%;height:100%;}
.twoImg{width:48%;height:100%;}
.threeImg{width:48%;height:50%;float:left}
.threeImg:nth-child(2){float:right;height:100%;}
.threeImg:last-child{width:48%;}
.fourImg{width:48%;height:48%;}


</style>
